import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-span-6" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = { class: "col-span-12" }
const _hoisted_4 = { class: "col-span-12" }
const _hoisted_5 = { class: "col-span-12" }
const _hoisted_6 = { class: "col-span-12" }
const _hoisted_7 = { class: "col-span-12" }
const _hoisted_8 = { class: "col-span-12" }
const _hoisted_9 = { class: "col-span-12" }
const _hoisted_10 = {
  key: 0,
  class: "grid grid-cols-2 gap-6"
}
const _hoisted_11 = { class: "col-span-12" }

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';

import { ref, onMounted, computed } from 'vue';

import { PackageType } from '@/enums/PackageType';
import { RiderType } from '@/enums/RiderType';
import { PatientType } from '@/enums/PatientType';
import { MaxUsageType } from '@/enums/MaxUsageType';
import { RequirementType } from '@/enums/RequirementType';
import { DiscountType } from '@/enums/DiscountType';
import { ValidityRangeType } from '@/enums/ValidityRangeType';

import { formattedRider } from '@/interfaces/CorporateBookingInterface'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    form: {
        type: Object,
        required: true
    },
    packages: {
        type: Array,
        default: () => [],
    },
    services: {
        type: Array,
        default: () => [],
    },
    allergyTests: {
        type: Array,
        default: () => [],
    },
    patients: {
        type: Array,
        default: () => [],
    },
    packageOptions: {
        type: Array,
        default: () => [],
    },
    riderOptions: {
        type: Array,
        default: () => [],
    },
    patientOptions: {
        type: Array,
        default: () => [],
    },
    maxUsageOptions: {
        type: Array,
        default: () => [],
    },
    requirementOptions: {
        type: Array,
        default: () => [],
    },
    discountOptions: {
        type: Array,
        default: () => [],
    },
    validityRangeOptions: {
        type: Array,
        default: () => []
    },
    errors: {
        type: Object,
        default: () => ({})
    }
},
  setup(__props) {

const props = __props

const form = ref(props.form)

const minDate = new Date;

const riderFormattedOptions = computed(() => {
    const result = [];
    const riderGroups = props.services.concat(props.allergyTests);
    riderGroups.forEach((riderGroup: any) => {
        riderGroup.items.forEach((unformattedRider: any) => {
            const formattedRider: formattedRider = {
                id   : null,
                label: null,
                value: null,
                disabledDates: null,
                name: null,
            };
    
            formattedRider.id    = unformattedRider.item_id;
            formattedRider.value = unformattedRider.item_id;
            formattedRider.label = unformattedRider.item_name;
            formattedRider.disabledDates = unformattedRider.disabledDates;
            formattedRider.name = unformattedRider.item_name;

            result.push(formattedRider);
        });
    });

    return result;
})

onMounted(async() => {
    // ...
})

return (_ctx: any,_cache: any) => {
  const _component_PageLoader = _resolveComponent("PageLoader")!
  const _component_ErrorModal = _resolveComponent("ErrorModal")!
  const _component_SuccessModal = _resolveComponent("SuccessModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FormSection, null, {
      title: _withCtx(() => [...(_cache[23] || (_cache[23] = [
        _createTextVNode(" Voucher Information ", -1)
      ]))]),
      description: _withCtx(() => [...(_cache[24] || (_cache[24] = [
        _createTextVNode(" Relevant data and other details ", -1)
      ]))]),
      form: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextInput, {
            id: "voucher_name",
            name: "voucher_name",
            label: "Voucher Name",
            placeholder: "Voucher Name",
            modelValue: form.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
            error: __props.errors.name ? __props.errors.name[0] : ''
          }, null, 8, ["modelValue", "error"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TextInput, {
            id: "voucher_code",
            name: "voucher_code",
            label: "Voucher Code",
            placeholder: "Voucher Code",
            modelValue: form.value.code,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.code) = $event)),
            error: __props.errors.code ? __props.errors.code[0] : '',
            customClass: "uppercase"
          }, null, 8, ["modelValue", "error"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(RadioGroup, {
            label: "Participating Packages",
            options: __props.packageOptions,
            name: "packages",
            keyID: "packages",
            modelValue: form.value.package_type,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.package_type) = $event)),
            error: __props.errors.package_type ? __props.errors.package_type[0] : ''
          }, null, 8, ["options", "modelValue", "error"]),
          (form.value.package_type === _unref(PackageType).SPECIFIC)
            ? (_openBlock(), _createBlock(MultiselectInput, {
                key: 0,
                name: "participating_package",
                placeholder: "Participating Packages",
                options: __props.packages,
                searchable: "",
                mode: "tags",
                modelValue: form.value.package_ids,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.package_ids) = $event)),
                error: __props.errors.package_ids ? __props.errors.package_ids[0] : ''
              }, null, 8, ["options", "modelValue", "error"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(RadioGroup, {
            label: "Participating Riders",
            options: __props.riderOptions,
            name: "riders",
            keyID: "riders",
            modelValue: form.value.rider_type,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.rider_type) = $event)),
            error: __props.errors.rider_type ? __props.errors.rider_type[0] : ''
          }, null, 8, ["options", "modelValue", "error"]),
          (form.value.rider_type === _unref(RiderType).SPECIFIC)
            ? (_openBlock(), _createBlock(MultiselectInput, {
                key: 0,
                name: "participating_riders",
                placeholder: "Participating Riders",
                options: riderFormattedOptions.value,
                searchable: "",
                mode: "tags",
                modelValue: form.value.rider_ids,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.rider_ids) = $event)),
                error: __props.errors.rider_ids ? __props.errors.rider_ids[0] : ''
              }, null, 8, ["options", "modelValue", "error"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(RadioGroup, {
            label: "Participating Patients",
            options: __props.patientOptions,
            name: "customers",
            keyID: "customers",
            modelValue: form.value.patient_type,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.patient_type) = $event)),
            error: __props.errors.patient_type ? __props.errors.patient_type[0] : ''
          }, null, 8, ["options", "modelValue", "error"]),
          (form.value.patient_type === _unref(PatientType).SPECIFIC)
            ? (_openBlock(), _createBlock(MultiselectInput, {
                key: 0,
                name: "participating_customer",
                placeholder: "Participating Customer",
                options: __props.patients,
                searchable: "",
                mode: "tags",
                modelValue: form.value.patient_ids,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.patient_ids) = $event)),
                error: __props.errors.patient_ids ? __props.errors.patient_ids[0] : ''
              }, null, 8, ["options", "modelValue", "error"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(RadioGroup, {
            label: "How many times can this be used?",
            options: __props.maxUsageOptions,
            name: "timesUsed",
            keyID: "timesUsed",
            modelValue: form.value.max_usage_type,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.max_usage_type) = $event)),
            error: __props.errors.max_usage_type ? __props.errors.max_usage_type[0] : ''
          }, null, 8, ["options", "modelValue", "error"]),
          (form.value.max_usage_type === _unref(MaxUsageType).LIMITED)
            ? (_openBlock(), _createBlock(TextInput, {
                key: 0,
                id: "max_usage",
                name: "max_usage",
                type: "number",
                min: 1,
                placeholder: "Max Order Count",
                modelValue: form.value.max_usage_count,
                "onUpdate:modelValue": [
                  _cache[9] || (_cache[9] = ($event: any) => ((form.value.max_usage_count) = $event)),
                  _cache[10] || (_cache[10] = (value) => (form.value.max_usage_count = value))
                ],
                error: __props.errors.max_usage_count ? __props.errors.max_usage_count[0] : ''
              }, null, 8, ["modelValue", "error"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(RadioGroup, {
            label: "Requirement Type",
            options: __props.requirementOptions,
            name: "requirement_type",
            keyID: "requirement_type",
            modelValue: form.value.requirement_type,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.requirement_type) = $event)),
            error: __props.errors.requirement_type ? __props.errors.requirement_type[0] : ''
          }, null, 8, ["options", "modelValue", "error"]),
          _createVNode(TextInput, {
            id: form.value.requirement_type === _unref(RequirementType).AMOUNT ? 'amount' : 'quantity',
            name: form.value.requirement_type === _unref(RequirementType).AMOUNT ? 'amount' : 'quantity',
            placeholder: form.value.requirement_type === _unref(RequirementType).AMOUNT ? 'Amount' : 'Quantity',
            addOnRight: form.value.requirement_type === _unref(RequirementType).AMOUNT ? true : false,
            addOnText: form.value.requirement_type === _unref(RequirementType).AMOUNT ? 'PHP' : '',
            modelValue: form.value.requirement_value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.requirement_value) = $event)),
            error: __props.errors.requirement_value ? __props.errors.requirement_value[0] : ''
          }, null, 8, ["id", "name", "placeholder", "addOnRight", "addOnText", "modelValue", "error"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(RadioGroup, {
            label: "Discount Type",
            options: __props.discountOptions,
            name: "discount_type",
            keyID: "discount_type",
            modelValue: form.value.discount_type,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.discount_type) = $event)),
            error: __props.errors.discount_type ? __props.errors.discount_type[0] : ''
          }, null, 8, ["options", "modelValue", "error"]),
          _createVNode(TextInput, {
            id: form.value.discount_type === _unref(DiscountType).PERCENTAGE ? 'percent' : 'fixed',
            name: form.value.discount_type === _unref(DiscountType).PERCENTAGE ? 'percent' : 'fixed',
            placeholder: form.value.discount_type === _unref(DiscountType).PERCENTAGE ? 'Percent' : 'Fixed',
            addOnRight: form.value.discount_type === _unref(DiscountType).PERCENTAGE ? true : false,
            addOnText: form.value.discount_type === _unref(DiscountType).PERCENTAGE ? '%' : 'PHP',
            modelValue: form.value.discount_value,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.discount_value) = $event)),
            error: __props.errors.discount_value ? __props.errors.discount_value[0] : ''
          }, null, 8, ["id", "name", "placeholder", "addOnRight", "addOnText", "modelValue", "error"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(RadioGroup, {
            label: "Validity Range",
            options: __props.validityRangeOptions,
            name: "validity_range",
            keyID: "validity_range",
            modelValue: form.value.validity_range_type,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.validity_range_type) = $event)),
            error: __props.errors.validity_range_type ? __props.errors.validity_range_type[0] : ''
          }, null, 8, ["options", "modelValue", "error"]),
          (form.value.validity_range_type === _unref(ValidityRangeType).LIMITED)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(DatePicker, {
                  id: "startDate",
                  name: "startDate",
                  placeholder: "Start Date",
                  label: "Start Date",
                  minDate: _unref(minDate),
                  modelValue: form.value.start_at,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.start_at) = $event)),
                  error: __props.errors.start_at ? __props.errors.start_at[0] : '',
                  timePicker: false,
                  enableTimePicker: false
                }, null, 8, ["minDate", "modelValue", "error"]),
                _createVNode(DatePicker, {
                  id: "endDate",
                  name: "endDate",
                  placeholder: "End Date",
                  label: "End Date",
                  minDate: _unref(minDate),
                  modelValue: form.value.end_at,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.end_at) = $event)),
                  error: __props.errors.end_at ? __props.errors.end_at[0] : '',
                  timePicker: false,
                  enableTimePicker: false
                }, null, 8, ["minDate", "modelValue", "error"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(TextInput, {
            label: "Description",
            id: "description",
            name: "description",
            placeholder: "Description",
            textarea: "",
            textAreaRows: "4",
            modelValue: form.value.description,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.description) = $event)),
            error: __props.errors.description ? __props.errors.description[0] : ''
          }, null, 8, ["modelValue", "error"])
        ])
      ]),
      actions: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }),
    (_ctx.loader)
      ? (_openBlock(), _createBlock(_component_PageLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ErrorModal, {
      width: "w-[548px]",
      title: "Error",
      "action-text": "Close",
      "cancel-text": "Go back",
      show: _ctx.showError,
      onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showError = false)),
      onConfirm: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showError = false)),
      errors: __props.errors
    }, {
      content: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.errorMsg), 1)
      ]),
      _: 1
    }, 8, ["show", "errors"]),
    _createVNode(_component_SuccessModal, {
      show: _ctx.showSuccess,
      onCancel: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showSuccess = false)),
      onConfirm: _cache[22] || (_cache[22] = ($event: any) => (_ctx.redirect())),
      "action-text": "Confirm",
      title: "Voucher Created!",
      content: "Voucher has been created successfully"
    }, null, 8, ["show"])
  ], 64))
}
}

})